"use client";

import { useAdmin } from "@/lib/admin/context";
import { Icon } from "@/lib/icons/Icon";
import styles from "./Tab.module.css";

/**
 * EditModeToggle — toggle przycisk w admin top bar otwierający/zamykający
 * panel `LayoutAndWindowsPanel` (drop-down z dragable oknami + wyborem layoutu).
 *
 * **Visit page ZAWSZE renderuje się jako visitor view** (`WindowAreaView` z
 * `WindowContainer` + rzeczywistym contentem) — niezależnie od trybu admin.
 * Admin edytuje przez ten panel (overlay nad visitor view), NIE przez
 * przełączanie całej strony na osobny edit canvas.
 *
 * **Toggle UX parity z `TabCatalog`** — wspólny `Tab.module.css`. Label i
 * ikona STAŁE niezależnie od stanu (active vs inactive); tylko `.tabActive`
 * class dodaje subtelny highlight + `title` attribute pokazuje czy klik
 * otworzy czy zamknie panel.
 *
 * Klik:
 *   - **activeTab=null -> 'layoutAndWindows'**: otwiera panel zarządzania
 *   - **activeTab='layoutAndWindows' -> null**: zamyka panel
 *   - **klik na inny tab** -> przełącza panele (poprzedni zamyka się automatycznie)
 */
export function EditModeToggle() {
  const { activeTab, setActiveTab, t } = useAdmin();
  const isActive = activeTab === "layoutAndWindows";

  return (
    <button
      type="button"
      className={isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab}
      onClick={() => setActiveTab(isActive ? null : "layoutAndWindows")}
      aria-pressed={isActive}
      aria-expanded={isActive}
      title={
        isActive
          ? t.topBar.editModeToggle.titleOpen
          : t.topBar.editModeToggle.titleClosed
      }
    >
      <Icon name="squares-four" className={styles.icon} />
      <span>{t.topBar.editModeToggle.label}</span>
    </button>
  );
}
